import React from "react";
import { statusColor } from "@/lib/format";

export function StatusBadge({ status, label }) {
  return (
    <span className={`badge-pill ${statusColor(status)}`} data-status={status}>
      {label || status}
    </span>
  );
}
